import React from 'react';
import { BulmaType, Message } from '@easylife365/react';
import { faExternalLink } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { ExpirationMessageProps } from './types';
import { useLicenseInfo } from '../../../lib/hooks';

const ExpirationMessage: React.FC<ExpirationMessageProps> = ({ showExpirationInDays }) => {
  const { t } = useTranslation('common', { keyPrefix: 'expirationMessage' });
  const { skuName, remainingDays } = useLicenseInfo();

  const showExpirationWarning = remainingDays && remainingDays > -1 && remainingDays < showExpirationInDays;

  if (!showExpirationWarning) return null;

  return (
    <Message
      bulmaType={BulmaType.Warning}
      title={t('title', { sku: skuName, count: remainingDays })}
      message={t('message')}
      ctaButtons={[
        {
          bulmaType: BulmaType.Primary,
          children: t('contactSales'),
          onClick: () => (window.location.href = 'mailto:sales@easylife365.cloud'),
        },
        {
          children: t('learnMore'),
          icon: faExternalLink,
          onClick: () => window.open('https://easylife365.cloud/products/identity/'),
        },
      ]}
    />
  );
};

export default ExpirationMessage;
